import * as z from "zod";
import { mutator } from "./mutator";

const updateOAuthAppSchema = z.object({
  id: z.string(),
  name: z.string().min(1).max(120).optional(),
  redirectUris: z.array(z.string().min(1).max(2048)).min(1).optional(),
  disabled: z.boolean().optional(),
});

export const updateOAuthApp = mutator({
  schema: updateOAuthAppSchema,
  resolve: {},
  permissions: {
    none: "compatibility no-op for the retired OAuth app registry",
  },
  fn: () => Promise.resolve(),
});
